/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlimTalkLogDto } from '../../models/alim-talk-log-dto';
import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface AlimTalkLogControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어 (수신자 이름, 연락처)
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo?: number;

/**
 * 카테고리 (문의, 사전등록, 참가신청)
 */
  category?: string;

/**
 * 출처
 */
  sourceType?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';
}

export function alimTalkLogControllerSearch(http: HttpClient, rootUrl: string, params?: AlimTalkLogControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<AlimTalkLogDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, alimTalkLogControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('category', params.category, {});
    rb.query('sourceType', params.sourceType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto & {
      'items'?: Array<AlimTalkLogDto>;
      }>;
    })
  );
}

alimTalkLogControllerSearch.PATH = '/api/api/v1/alim-talk/log/search';
